var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"rounded-full btn btn-primary font-bold px-6",attrs:{"type":"submit"},on:{"click":_vm.attemptPublish}},[_vm._v("Publish Job")])])
}
var staticRenderFns = []

export { render, staticRenderFns }